import React from 'react';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';
import { KF_URL } from 'src/tools/config';
import { Spin } from 'antd';
import { DragHoc } from 'src/components/Drag';
import { getI18nFromGeneral } from '@/src/tools/tools';

// const CollapseHeader = (props) => {
//   const { setOpen, open } = props;
//   return (
//     <div
//       className={css.clickableContainer}
//       draggable='true'
//       onClick={() => setOpen(true)}
//       style={{ display: open ? 'none' : 'block' }}
//       id='customer_service_header'>
//       <Icon type='iconservice' style={{ marginRight: 12 }} />
//       {getI18nFromGeneral('general.customerServiceModal.support')}
//     </div>
//   );
// };

const CustomerService = () => {
  // const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  //  const [firstLoaded, setFirstLoaded] = React.useState(true);
  // React.useEffect(() => {
  //   if (open && !firstLoaded) {
  //     setFirstLoaded(true);
  //   }
  // }, [open]);
  return (
    <React.Fragment>
      {/* <CollapseHeader open={open} setOpen={setOpen} /> */}
      <div className={css.iframeContainer}>
        <div className={css.titleContainer}>
          <Icon type='iconservice' style={{ marginRight: 12 }} />
          {getI18nFromGeneral('general.customerServiceModal.support')}
          {/* <Icon
            type='iconfalse'
            className={css.closeIcon}
            onClick={() => setOpen(false)}
          /> */}
        </div>
        <Spin spinning={loading}>
          <div className={css.iframe}>
            <iframe
              //sandbox='true'
              sandbox='allow-scripts allow-forms allow-pointer-lock allow-same-origin'
              onLoad={() => {
                setLoading(false);
              }}
              title='kf'
              id='kf_frame_container'
              src={KF_URL}
              style={{ width: '100%', height: '100%' }}></iframe>{' '}
          </div>
        </Spin>
      </div>
    </React.Fragment>
  );
};

const Service = DragHoc(CustomerService, 'customer_service_header');

export { CustomerService };
export default Service;
